import React from "react";

const partners = [
  { name: "Y Combinator", url: "https://www.ycombinator.com/cofounder-matching", description: "YC's official co-founder matching platform for startup founders." },
  { name: "CoFoundersLab", url: "https://cofounderslab.com", description: "The largest network for entrepreneurs to find co-founders, advisors, and interns." },
  { name: "CofounderCloud", url: "https://www.foundercloud.com", description: "Finding a co-founder is hard, we provide you with the platform to make that easier." },
  { name: "FounderNest", url: "https://foundernest.com", description: "AI-powered platform matching startups with the right partners and investors." },
  { name: "Startup School (YC)", url: "https://www.startupschool.org", description: "YC's free online program and community for aspiring founders." },
  { name: "CoffeeSpace", url: "https://www.coffeespace.com", description: "CoffeeSpace is an AI-powered talent matching platform built for early-stage startups." },
  { name: "Wellfound", url: "https://wellfound.com", description: "Find and engage talent from millions of AI-enriched profiles with powerful search, CRM, and email sync" },
  { name: "Founders Nation", url: "https://founders-nation.com", description: "A community for startup founders to meet co-founders, advisors, and investors." },
  { name: "TeamUp", url: "https://www.teamup.com", description: "A platform designed to connect people with complementary skills to form successful startup teams." },
  { name: "The Founder Institute", url: "https://fi.co", description: "A global startup accelerator that helps entrepreneurs find co-founders and connect with others." },
  { name: "Techstars", url: "https://www.techstars.com", description: "A renowned accelerator that helps entrepreneurs find co-founders and team members, with investment, mentorship, and resources." },
  { name: "WeWork Labs", url: "https://www.wework.com", description: "A global network of startup workspaces offering mentoring and access to a community of entrepreneurs looking for co-founders." }
];

const ExternalLinkIcon = () => (
  <svg className="partner-card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

function PartnerSites() {
  return (
    <section className="partners">
      <div className="section-container">
        <h2 className="section-title">Partner & Related Platforms</h2>
        <p className="section-subtitle">
          Explore trusted co-founder connecting platforms across the startup ecosystem.
        </p>
        <div className="partners-grid">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="partner-card"
            >
              <div className="partner-card-header">
                <h3>{partner.name}</h3>
                <ExternalLinkIcon/>
              </div>
              <p>{partner.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PartnerSites;
